/**
 * Injectable defaults for the Tooltip primitive.
 *
 * Production uses the hardcoded values (400 / 300 ms); the test setup
 * calls `setTooltipDefaults({ delayDuration: 0, skipDelayDuration: 0 })`
 * so Radix opens immediately and no timer fires outside act().
 */

export const tooltipDefaults = {
  delayDuration: 400,
  skipDelayDuration: 300,
};

/**
 * Override one or both defaults. Called once from `src/test/setup.ts`.
 * Tooltip.tsx reads `tooltipDefaults` at render, so subsequent renders
 * pick up the override immediately.
 */
export function setTooltipDefaults(
  partial: Partial<typeof tooltipDefaults>,
): void {
  if (partial.delayDuration !== undefined) {
    tooltipDefaults.delayDuration = partial.delayDuration;
  }
  if (partial.skipDelayDuration !== undefined) {
    tooltipDefaults.skipDelayDuration = partial.skipDelayDuration;
  }
}
